import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class LearnSourceGroupService {
  static getLearnSourceGroups(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE_GROUP}?pageSize=${limit}&page=${page}`)
  }

  static getLearnSourceGroup(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE_GROUP}/${id}`)
  }

  static addLearnSourceGroup(learnSourceGroup) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE_GROUP}`, {
      method: 'POST',
      body: JSON.stringify({
        learnSourceGroup
      })
    })
  }

  static updateLearnSourceGroup(learnSourceGroup) {
    if (typeof learnSourceGroup._id === 'undefined') {
      return this.addLearnSourceGroup(learnSourceGroup)
    }

    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE_GROUP}/${learnSourceGroup['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        learnSourceGroup
      })
    })
  }

  static deleteLearnSourceGroup(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE_GROUP}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default LearnSourceGroupService
